import { Text, TextLabel } from '@tonic-one/react';
import style from '../../index.module.less';
import { useTranslation } from 'react-i18next';

const ReportTemplate = () => {
  const { t } = useTranslation();
  // const templateList = useMemo(() => {
  //   return TEMPLATE_LIST.map((item) => {
  //     return { key: item.key, value: t(item.value) };
  //   });
  // }, [t]);
  return (
    <>
      <TextLabel className={style.itemLabel}>
        {t('reportCommon.labels.template')}:
      </TextLabel>
      <Text pt="6px">{t('dashboard.tabs.threatDetection')}</Text>
      {/* {templateList.length === 1 ? (
        <Text pt="6px">{templateList[0].value}</Text>
      ) : (
        <MenuWithLabel
          menuItems={templateList}
          minWidth={304}
          selectedKey={template}
          onClick={(e: any) => {
            setTemplate(e.target.getAttribute('value'));
          }}
        />
      )} */}
    </>
  );
};

export default ReportTemplate;
